import theme from "@/theme";

export const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "520px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    bgcolor: "#fff",
    padding: "56px 64.5px 40px 64.5px",
    boxShadow: "0px 0px 25px 0px rgba(22, 22, 22, 0.05)",
    borderRadius: "1.5rem",
  },
  inputLabel: {
    fontSize: "1rem",
    color: theme.palette.custom.blueGray900,
    position: "absolute",
    fontWeight: 500,
    left: "-13px !important",
  },

  inputProps: {
    sx: {
      marginTop: "0.625rem",
      borderRadius: "3.125rem",
      fontSize: "1rem",
    },
  },

  continueButton: {
    py: 1.5,
    fontSize: "1rem",
    textTransform: "none",
    borderRadius: "1.75rem",
  },

  timer: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: "#2A2D31",
    marginLeft: "4px",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },

  link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "22px",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  back: {
    position: "absolute",
    top: 30,
    left: 30,
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
};
